import {
  LandingPageNumber,
  VehiclePageNumber,
  OptionsPageNumber,
  AftermarketPageNumber,
  HistoryPageNumber,
  ImageCapturePageNumber,
  ExteriorPageNumber,
  InteriorPageNumber,
  MechanicalPageNumber,
  ContactPageNumber,
  SummaryPageNumber,
  LoadingPageNumber,
  CertificatePageNumber
} from '../constants'

export const EXTERIOR_TAGS = {
  driverside: 'driverdmg',
  rear: 'reardmg',
  passengerside: 'pasngrdmg',
  frontwithgrille: 'frontdmg',
  glasslights: 'glassdmg',
  'Tires & Rims': 'tiresdmg',
  Brakes: 'brakesdmg'
}

export const INTERIOR_TAGS = {
  interior: 'interiordmg',
  ABS: 'abswarn',
  Airbags: 'airbagswarn',
  'Check Engine': 'chkengwarn',
  'Service Engine': 'servwarn',
  'Low Coolant': 'coolantwarn',
  Maintenance: 'maintwarn',
  'Oil Pressure': 'oilwarn',
  Odors: 'odors'
}

export const MECHANICAL_TAGS = {
  Engine: 'enginemech',
  Transmission: 'transmech',
  Steering: 'steermech',
  Exhaust: 'exhaustmech',
  Suspension: 'suspenmech',
  'Heating/Air Conditioning': 'heatairmech',
  'Battery/Electrical': 'battmech',
  Stereo: 'stereomech',
  Odometer: 'odommech',
  'Sunroof/Moonroof': 'sunroofmech',
  Airbags_mech: 'airbagmech',
  'Frame/Structural': 'framemech',
  'Frame & Structural': 'structmech'
}

const VEHICLE_CONDITION_TAGS = {
  ...EXTERIOR_TAGS,
  ...INTERIOR_TAGS,
  ...MECHANICAL_TAGS
}

const PAGE_INFO = {
  [LandingPageNumber]: {
    pageName: 'timbuybkhome',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkhome_selltrade',
    friendlyPageName: 'Landing Page'
  },
  [VehiclePageNumber]: {
    pageName: 'timbuybkvehdetails',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkvehdetails_selltrade',
    friendlyPageName: 'Vehicle Details Page',
    tags: { amQ: 'mod', 'qp/79': 'keys' }
  },
  [OptionsPageNumber]: {
    pageName: 'timbuybkopt',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkopt_selltrade',
    friendlyPageName: 'Vehicle Options Page'
  },
  [AftermarketPageNumber]: {
    pageName: 'timbuybkaftmkt',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkaftmkt_selltrade',
    friendlyPageName: 'Aftermarket Details Page',
    tags: { Stereo: 'stereo', 'Wheels & Tires': 'wheels', Suspension: 'suspen', 'Remote Start': 'remote', Exhaust: 'exhaust', Spoiler: 'spoiler', 'Performance Modifications': 'perf', 'Window Tint': 'tint', Other: 'other' }
  },
  [HistoryPageNumber]: {
    pageName: 'timbuybkvehhist',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkvehhist_selltrade',
    friendlyPageName: 'Vehicle History Page',
    tags: { 'qp/83': 'owner', 'qp/82': 'payments', 'qp/124': 'vehreport', 'qp/76': 'insure', 'qp/17': 'maintrecs', 'qp/81': 'auction', 'qp/125': 'rental' }
  },
  [ImageCapturePageNumber]: {
    pageName: 'timbuybkcondquiz',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkcondquiz_selltrade_img',
    friendlyPageName: 'Image Capture Page'
  },
  [ExteriorPageNumber]: {
    pageName: 'timbuybkcondquiz',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkcondquiz_selltrade_ext',
    friendlyPageName: 'Exterior Condition Page',
    tags: VEHICLE_CONDITION_TAGS
  },
  [InteriorPageNumber]: {
    pageName: 'timbuybkcondquiz',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkcondquiz_selltrade_int',
    friendlyPageName: 'Interior Condition Page',
    tags: VEHICLE_CONDITION_TAGS
  },
  [MechanicalPageNumber]: {
    pageName: 'timbuybkcondquiz',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkcondquiz_selltrade_mech',
    friendlyPageName: 'Mechanical Condition Page',
    tags: VEHICLE_CONDITION_TAGS
  },
  [ContactPageNumber]: {
    pageName: 'timbuybkcontact',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkcontact_selltrade',
    friendlyPageName: 'Contact Details Page'
  },
  [SummaryPageNumber]: {
    pageName: 'timbuybkedit',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkresbmt_selltrade',
    friendlyPageName: 'Review Page'
  },
  [LoadingPageNumber]: {
    pageName: 'timbuybkload',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkload_selltrade',
    friendlyPageName: 'Loading Page'
  },
  [CertificatePageNumber]: {
    pageName: 'timbuybkthank',
    sectionName: 'timmktplace',
    superSectionName: 'used',
    detailPageName: 'timbuybkthank_selltrade',
    friendlyPageName: 'Certificate Page'
  }
}

const questionAnswerMap = ['yes', 'no', 'notsure']

const mapPage = page => PAGE_INFO[page]

const mapPageTags = (impressionTags, page, globalState) => {
  let mappedPage = mapPage(page)

  // Update tag mapping on vehicle details page for vehicle details and modifications component - G6
  if (globalState?.isVehicleDetailsComponentEnabled === true && (page === 1 || page === 2)) {
    mappedPage = { ...mappedPage, tags: { mods: 'mods', twokeys: 'keys', stereo: 'stereo', wheelstires: 'wheels_tires', suspension: 'suspension', performance: 'performance', exhaust: 'exhaust' } }
  }
  const pageTags = mappedPage && mappedPage.tags
  return impressionTags.map(tag => {
    // Mapped impressions
    if (pageTags && tag.value !== undefined) {
      let answer = ''
      if (typeof tag.value === 'boolean') {
        answer = tag.value ? 'yes' : 'no'
      } else {
        answer = questionAnswerMap[tag.value]
      }
      return pageTags[tag.key] && answer && `${pageTags[tag.key]}_${answer}`
    }

    // Non-mapped impressions
    return tag.key
  })
}

export { mapPage, mapPageTags }
